import { Organization } from "./organization.model";

export class User {
  constructor(
    public id: string = "",
    public userName: string = "",
    public role: string = "",
    public accessToken?: string,
    public refreshToken?: string,
    public userConfiguration: UserConfigs = new UserConfigs(),
    public globalConfiguration: AttentionConfig = new AttentionConfig(),
    public photoProfile?: any,
    public firstName?: string
  ) {}
}

export class UserConfigs {
  constructor(public attentionEnabled: boolean = false) {}
}

class AttentionConfig {
  constructor(public attentionConfig: GlobalConfigs = new GlobalConfigs()) {}
}

export class GlobalConfigs {
  constructor(
    public attentionEnabled: boolean = false,
    public secondsBetweenDetector: number = 10,
    public obligatoryPresence: boolean = true,
    public headAngleThreshold: number = 40,
    public presenceThreshold: number = 50,
    public detectionInterval: number = 10
  ) {}
}

export class Users {
  constructor(
    public birthDate: any = null,
    public cpf: string = "",
    public id: string = "",
    public login: string = "",
    public name: string = "",
    public organization: Organization = new Organization(),
    public role: string = "",
    public status: string = ""
  ) {}
}

export class Roles {
  public static readonly ADMINISTRATOR = "ADMINISTRATOR";
  public static readonly STUDENT = "STUDENT";
  public static readonly TEACHER = "TEACHER";
  public static readonly APPLICATION_ADMIN = "APPLICATION_ADMIN";
}

export class Status {
  public static readonly ACTIVATED = "ACTIVATED";
  public static readonly BLOCKED = "BLOCKED";
  public static readonly INACTIVATED = "INACTIVATED";
  public static readonly WAITING_ACTIVATION = "WAITING_ACTIVATION";
  public static readonly CONCLUDED = "CONCLUDED";
  public static readonly PROGRESS = "PROGRESS";
}

export class UserForm {
  constructor(
    public cpf: string = "",
    public login: string = "",
    public name: string = "",
    public organization: Organization = new Organization(),
    public role: string = "",
    public birthDate: any = null,
    public status: Status = Status.WAITING_ACTIVATION,
    public courses?: any
  ) {}
}

export class UserStudentForm {
  constructor(
    public user: UserForm = new UserForm(),
    public courses: string[] = []
  ) {}
}

export class TeacherProfile {
  constructor(
    public id: string = "",
    public title: string = "",
    public description: string = "",
    public generalUrl: string = "",
    public lattesUrl: string = "",
    public linkedinUrl: string = ""
  ) {}
}

export class CsvFile {
  constructor(
    public file: Csv = new Csv(),
    public errors: any = "",
    public csv: string = "",
    public fileError: any = true
  ) {}
}

class Csv {
  constructor(
    public name: string = "",
    public type: string = "",
    public size: any = null
  ) {}
}

export class UserForum {
  constructor(
    public id?: string,
    public name: string = "",
    public role: string = "",
    public accessToken?: string,
    public refreshToken?: string,
    public userConfiguration: UserConfigs = new UserConfigs(),
    public globalConfiguration: AttentionConfig = new AttentionConfig(),
    public photoProfile?: any,
    public firstName?: string,
    public additionalInformation: AdditionalInformation = new AdditionalInformation(),
    public path?: string
  ) {}
}

export class AdditionalInformation {
  constructor(public avatar: string = "", id: string = "") {}
}
